import React from 'react'


import { IManualVerificationPageProps, ManualVerificationPageContentProps } from './models/IManualVerificationPageModel'
import useManualVerificationPageLogic from './hooks/useManualVerificationPageLogic'
import { apphistory } from '../../store'
import { AppLinks } from '../../environment/app-links'
import useTextContents from '../../hooks/useTextContents'

import Paragraph from '../../components/atoms/Paragraph/Paragraph'
import PageScreen from '../../components/organisms/Page/PageScreen'
import AppButton from '../../components/atoms/AppButton/AppButton'
import { APP_COLOR, APP_FONT_SIZE } from '../../components/atoms/AtomsGlobalProps'
import LoanOfferSummaryPanel from '../../components/organisms/LoanOfferSummaryPanel/LoanOfferSummaryPanel'


import {ReactComponent as ManualVerificationIcon} from '../../icons/svg/manual-verification-page-icon.svg'
import './ManualVerificationPage.scss'


/**
 * Treść komunikatu na stronie
 * @returns 
 */
const ManualVerificationPageContent = (props: ManualVerificationPageContentProps) => {

   const { 
      showManualVerificationClosePage, clientConsentManualVerificationHasError,
      isConfirmationButtonLoading, confirmManualVerificationDefaultMethod, textContent
   } = props


   if(showManualVerificationClosePage){
      return (
         <Paragraph size={APP_FONT_SIZE.SMALL} color={APP_COLOR.GRAY} align={"center"}>
            {props.textContent('manualVerificationPage.tip')}
         </Paragraph>
      )
   }
   else {
      return (
         <>
            <div className='manual-verification-confirm-default-method-button-outer-wrapper'>
               <AppButton onClick={confirmManualVerificationDefaultMethod} isLoading={isConfirmationButtonLoading} >
                  {textContent('buttons.confirmVideoVerificationDefaultMethod')}
               </AppButton>
               {
                  clientConsentManualVerificationHasError ?
                     (
                        <Paragraph className='manual-verification-confirm-default-method-error' color={APP_COLOR.ERROR} size={APP_FONT_SIZE.EXTRA_SMALL}>
                           {textContent('manualVerificationPage.confirmDefaultMethodErrorText')}
                        </Paragraph>
                     )
                     :
                     (<span className='manual-verification-confirm-default-method-error-placeholder' />)
               }
            </div>
         </>
      )
   }
}

const ManualVerificationPage = (props: IManualVerificationPageProps) => {
   const textContent = useTextContents()
   const { isManualVerificationFailPage } = props

   const { 
      confirmManualVerificationDefaultMethod, 
      htmlContentBasedOnDate, htmlContentDetailsBasedOnDate, isConfirmationButtonLoading,
      clientConsentManualVerificationHasError
   } = useManualVerificationPageLogic()
   

   const onClickBack = () => apphistory.push(AppLinks.clientChoiceManualVerification) 

   return (
      <PageScreen
         title={isManualVerificationFailPage? {title:  'Nie udało nam się potwierdzić Twoich danych', line: true} : {title: 'Porozmawiaj z nami', line: true}}
         icon={ { icon: ManualVerificationIcon, decorative: true, color: 'var(--color-primary-600)' } }
         panel={<LoanOfferSummaryPanel readOnly={true} loanVariant='selectedOffer' />}
         {...(isManualVerificationFailPage ? { showBackButton: false } : { showBackButton: true, onClickBack })} //Pokazujemy przycisk powrotu tylko na konkretnej stronie
      >
         {
            (
               <>
                  <div className='manual-verification-description'>
                     <Paragraph html={ htmlContentBasedOnDate } />
                     <Paragraph html={htmlContentDetailsBasedOnDate} />
                  </div>
                  <ManualVerificationPageContent
                     textContent={textContent}
                     confirmManualVerificationDefaultMethod={confirmManualVerificationDefaultMethod}
                     htmlContentBasedOnDate={htmlContentBasedOnDate}
                     showManualVerificationClosePage={isManualVerificationFailPage}
                     isConfirmationButtonLoading={isConfirmationButtonLoading}
                     clientConsentManualVerificationHasError={clientConsentManualVerificationHasError}
                  />
               </>
            )
         }
      </PageScreen>
   )
}

export default ManualVerificationPage;